import { render, staticRenderFns } from "./TransbankPayment.vue?vue&type=template&id=24b93a90&lang=pug&"
import script from "./TransbankPayment.vue?vue&type=script&lang=js&"
export * from "./TransbankPayment.vue?vue&type=script&lang=js&"
import style0 from "./TransbankPayment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TransbankPayment.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VDivider,
  VSwitch,
  VTextField,
})
